import { IonItemDivider, IonLabel } from "@ionic/react";
import React from "react";
import { useSelector } from "react-redux";
import { selectUsersFiltered } from "../../../store/users/selectors/selectUsersFiltered";
import { UserListItem } from "./UserListItem";

export const UsersListContainer: React.FC = () => {
  const users = useSelector(selectUsersFiltered);
  return (
    <>
      <IonItemDivider class="ion-margin-bottom">
        <IonLabel>
          <p>{users.length} resultados</p>
        </IonLabel>
      </IonItemDivider>
      {users.slice(0, 60).map((user) => (
        <UserListItem user={user} key={user.id} />
      ))}
    </>
  );
};
